import { render, staticRenderFns } from "./type22.vue?vue&type=template&id=1a60bb1a&scoped=true"
import script from "./type22.vue?vue&type=script&lang=js"
export * from "./type22.vue?vue&type=script&lang=js"
import style0 from "./type22.vue?vue&type=style&index=0&id=1a60bb1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a60bb1a",
  null
  
)

export default component.exports